import InfoIcon from "@mui/icons-material/Info";
import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../../../components/CustomTooltip";
import {
  getPrettyDateTime,
  useLocalTime,
} from "../../../../../../../utils/timestamp";

const ExclusionInformationIcon = ({ misconfiguration }) => {
  const showLocalTime = useLocalTime();
  const colors = useColors();

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <CustomToolTip
        title={
          <Box>
            <Typography variant="caption" sx={{ fontWeight: 500 }}>
              Excluded On:{" "}
            </Typography>
            <Typography variant="caption">
              {getPrettyDateTime(
                misconfiguration?.exclusion_details?.excluded_at?.timestamp_utc,
                showLocalTime
              )}{" "}
              by{" "}
              {misconfiguration?.exclusion_details?.excluded_by_name ??
                misconfiguration?.exclusion_details?.excluded_by_email}
            </Typography>
            {misconfiguration?.exclusion_details?.exclusion_reason && (
              <Box sx={{ mt: 0.5 }}>
                <Typography variant="caption" sx={{ fontWeight: 500 }}>
                  Reason:{" "}
                </Typography>
                <Typography variant="caption">
                  {misconfiguration?.exclusion_details?.exclusion_reason}
                </Typography>
              </Box>
            )}
          </Box>
        }
        placement="top"
      >
        <InfoIcon
          sx={{
            width: "16px",
            height: "16px",
            color: colors.tooltip_info_icon,
            cursor: "pointer",
          }}
        />
      </CustomToolTip>
    </Box>
  );
};

export default ExclusionInformationIcon;
